// cbdv: small site-wide behaviours, kept out of Dawn's files so theme updates don't touch them.
// Loaded with defer from snippets/cbdv-body-end.liquid. See CUSTOMIZATIONS.md.

// Social profile links open in a new tab, so the shop stays open behind Instagram/Facebook.
document.querySelectorAll('a.list-social__link').forEach((link) => {
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
});
